import React, {useEffect, useState} from "react";
import {Col, FormGroup, Label, Row} from "reactstrap";
import {useSelector} from "react-redux";
import Select from "react-select";


// providers
import {udnProvider} from "../../../../providers/udnProvider";
import {activityProvider} from "../../../../providers/activityProvider";

// utils
import {getStateByPath} from "../../../../redux/selectors";



const ActivitiesByUdn = props => {
    const {
        path,
        setExternalValues = () => console.warn("setExternalValues not implemented"),
    } = props


    const componentState = useSelector(state => getStateByPath(state, path));
    const { app, domainObject } = componentState?.data || {};
    const { udn, activity } = domainObject || {}

    const udnId = udn?.id
    const activityId = activity?.id

    const [udns, setUdns] = useState(undefined)
    const [selectedUdn, setSelectedUdn] = useState(null)
    const [loadingUdns, setLoadingUdns] = useState(true)


    const [activities, setActivities] = useState(undefined)
    const [selectedActivity, setSelectedActivity] = useState(null)
    const [loadingActivities, setLoadingActivities] = useState(false)





    // Cargar las unidades de negocio
    useEffect(() => {
        loadUdns()
    }, []);


    // Cargar las unidades de negocio
    useEffect(() => {
        loadActivities()
    }, [selectedUdn]);




    const loadUdns =  () => {
        setLoadingUdns(true)

        udnProvider.getOptions().then( result => {
            setUdns(result)

            if(udnId){
                const sel = result.find( u => u.id === udnId)
                setSelectedUdn(sel)
            }
        }).catch( e => {
            console.error(e)
        }).finally(() => {
            setLoadingUdns(false)
        })
    }



    const loadActivities = () => {
        setSelectedActivity(null)

        if(!selectedUdn){
            setActivities(undefined)
            return
        }



        const filters = {
            onlyRegistered:true,
            fbDataBase : { id :app?.fbDataBase?.id },
            item:{
                udn: { id: selectedUdn.id },
                isExtraordinary: true
            }
        }

        setLoadingActivities(true)

        activityProvider.getOptions(filters).then( result => {
            setActivities(result)
            if(activityId){
                const sel = result.find( a => a.id === activityId)
                setSelectedActivity(sel)
                setExternalValues(selectedUdn, sel)
            }
        }).catch( e => {
            console.error(e)
        }).finally(() => {
            setLoadingActivities(false)
        })
    }



    const handleActivityChange = activity => {
        setSelectedActivity(activity)
        setExternalValues(selectedUdn, activity)
    }



    return <Row>
        <Col>
            <FormGroup>
                <Label className={(!selectedUdn ? 'label-is-invalid' : '')}>Unidad de negocio:</Label>
                <Select
                    value={ selectedUdn }
                    options={ udns }
                    isClearable={ true }
                    onChange={ setSelectedUdn}
                    className={`select-generic ${ !selectedUdn ? "is-invalid" : "" }`}
                    isLoading={ loadingUdns }
                    placeholder={ loadingUdns ? "Cargando unidades de negocio..." : "Selecciona una unidad de negocio" }
                    noOptionsMessage={() => "No hay unidades de negocio disponibles"}
                />
                { !selectedUdn && <div className="invalid-feedback" style={{'display':'block'}}> Debes seleccionar una unidad de negocio </div> }
            </FormGroup>
        </Col>
        <Col>
            <FormGroup>
                <Label className={(!selectedActivity ? 'label-is-invalid' : '')}>Actividad a promocionar:</Label>
                <Select
                    value={ selectedActivity }
                    options={ activities }
                    isClearable={ true }
                    onChange={ handleActivityChange }
                    className={`select-generic ${ !selectedActivity ? "is-invalid" : "" }`}
                    isLoading={ loadingActivities }
                    placeholder={
                        loadingActivities
                            ? "Cargando actividades..."
                            : !selectedUdn
                                ? "Primero selecciona una unidad de negocio"
                                : !activities || activities.length === 0
                                    ? "No hay actividades disponibles"
                                    : "Selecciona una actividad"
                }
                    noOptionsMessage={() => !selectedUdn ? "Para cargar las actividades debes seleccionar una unidad de negocio" : "No hay actividades disponibles"}
                />
                { !selectedActivity && <div className="invalid-feedback" style={{'display':'block'}}> {!selectedUdn ? 'Para cargar las actividades debes seleccionar una unidad de negocio' : 'Debes seleccionar una actividad'} </div> }
            </FormGroup>
        </Col>
    </Row>
}



export default ActivitiesByUdn;